<template>
  <div>
    <b-row>
      <b-col
        class="mb-2"
        cols="12"
      >
        <h5 class="mb-0">
          {{ $t('message.behaviour_title') }}
          <br>
          <small
            class="text-muted"
          >{{ $t('message.behaviour_desc') }}
          </small>
          <br>
          <small
            class="text-muted"
          >
            <feather-icon
              icon="MoveIcon"
              size="14"
              class="mr-25"
            />{{ $t('message.drag_to_reorder') }}
          </small>
        </h5>
      </b-col>
    </b-row>
    <div>
      <b-form
        ref="form"
        class="repeater-form"
        @submit.prevent="repeatAgain"
      >
        <b-row
          v-for="(row, index) in items"
          v-show="!row.deleted"
          :key="row.uid"
          ref="row"
          class="border-bottom mb-1"
        >
          <b-col md="12">
            <h6>
              {{ $t('label.activity') }} :
              <span
                class="text-primary font-medium-3"
              >{{ row.mainTitle }}
              </span>
            </h6>
          </b-col>

          <b-col md="12">
            <draggable
              v-model="row.singleRow"
              tag="div"
              handle=".behaviour-drag-handle"
              @update="onBehaviourReorder($event, index)"
            >
              <b-row
                v-for="(singleRowInputs, loopIndex) in row.singleRow"
                :key="singleRowInputs.uid"
              >
                <b-col
                  cols="auto"
                  class="d-flex align-items-center pr-1"
                >
                  <feather-icon
                    icon="MoveIcon"
                    size="18"
                    class="behaviour-drag-handle"
                  />
                </b-col>
                <b-col
                  v-for="(input, colIndex) in singleRowInputs.rowInputs"
                  :key="colIndex"
                  :md="input.md"
                >
                  <GlobalSingleInput
                    :key="colIndex"
                    :input="input"
                  />
                </b-col>
                <b-col
                  v-if="loopIndex > 0"
                  md="1"
                >
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index, loopIndex)"
                  >
                    <feather-icon icon="XIcon" />
                    <!-- <span class="ml-25">{{ $t('message.delete') }}</span> -->
                  </b-button>
                </b-col>
              </b-row>
            </draggable>
          </b-col>
          <b-col mf="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :class="{ 'mb-2': items.length > 0 }"
              variant="primary"
              @click="repeatAgain(index, row.mainTitle)"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>{{ $t('message.Add_New_Behaviour_to_Activity') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import GlobalSingleInput from '@/views/components/form/GlobalSingleInput.vue'
import _ from 'lodash'
import store from '@/store'
import constants from '@/constants'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, idToString } from '@/helpers/mongoHelpers'

let rowUid = 0

export default {
  directives: {
    Ripple,
  },
  components: {
    GlobalSingleInput,
    draggable,
  },
  mixins: [heightTransition],
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    data: { type: Array, default: [] },
    // eslint-disable-next-line vue/require-valid-default-prop
    addedActivities: { type: Array, default: [] },
  },
  data() {
    return {
      items: [],
      questionTypeOptions: [],
    }
  },
  watch: {
    /* data(value) {
      if (value.length) {
        value.forEach(val => {
          setTimeout(log)
          const index = _.find(this.items, { mainTitle: val.activity })
          console.log('index'.index)
        /!*  val.behaviours.forEach(behaviour => {
            this.repeatAgain(index, behaviour, val.activity)
          })*!/
        //  this.repeatAgain(qualification)
        })
        /!* this.items.forEach((item, index) => {
          this.items[index].singleRow.rowInputs[0].value = value[index]
        })
        this.trAddHeight(value.length * 90) *!/
      }
    }, */
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    this.getQuestionTypes()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeatAgain(index, activity, value = null, typeValue = null, questionTypeValue = null) {
      let { length } = this.items[index].singleRow
      // eslint-disable-next-line no-plusplus
      length = ++length
      this.items[index].singleRow.push({
        uid: rowUid++,
        rowInputs: [
          {
            md: 5,
            label: i18n.tc('message.behaviour_no', 0, {count: `${index + 1}.${length}`}),
            type: 'quill',
            key: `behaviour_${index + 1}.${length}`,
            rules: 'required',
            placeholder: i18n.t('placeholder.activity'),
            value: value ?? '',
          },
          {
            md: 2,
            label: i18n.tc('message.type_no', 0, {count: `${index + 1}.${length}`}),
            type: 'select',
            key: `behaviour_${index + 1}.${length}_type`,
            rules: 'required',
            options: constants.types,
            placeholder: i18n.t('placeholder.type'),
            value: typeValue ?? '',
          },
          {
            ...this.questionTypeInput(`${index + 1}.${length}`),
            value: questionTypeValue ?? [],
          },
        ],
      })

      this.$nextTick(() => {
        this.trAddHeight(100)
      })
    },
    questionTypeInput(count) {
      return {
        md: 3,
        label: i18n.t('label.question_type'),
        type: 'select',
        key: `behaviour_${count}_question_type`,
        rules: '',
        multiple: true,
        reduce: option => option.value,
        options: this.questionTypeOptions,
        placeholder: i18n.t('placeholder.question_type'),
        value: [],
      }
    },
    async getQuestionTypes() {
      try {
        const userData = store.state?.userStore?.userData
        const clientId = userData.role !== 'admin' ? userData.client.$oid : null
        const { getItems } = useLambda()
        const items = await getItems({
          collection: 'question_type',
          query: { client_id: oid(clientId), deleted: { $ne: true } },
        })

        this.questionTypeOptions.push(...(items || []).map(({ name, _id }) => ({ title: name, value: idToString(_id) })))
      } catch (error) {
        console.log(error)
      }
    },
    removeItem(index, itemIndex) {
      this.items[index].singleRow.splice(itemIndex, 1)
      this.trAddHeight(-100)
      this.relabelRows(index)
    },
    onBehaviourReorder({ oldIndex, newIndex }, activityIndex) {
      if (oldIndex === newIndex) return
      this.relabelRows(activityIndex)
    },
    relabelRows(activityIndex) {
      const item = this.items[activityIndex]
      if (!item) return
      item.singleRow.forEach((singleRow, rowIndex) => {
        const count = `${activityIndex + 1}.${rowIndex + 1}`
        singleRow.rowInputs[0].label = i18n.tc('message.behaviour_no', 0, {count})
        singleRow.rowInputs[0].key = `behaviour_${count}`
        singleRow.rowInputs[1].label = i18n.tc('message.type_no', 0, {count})
        singleRow.rowInputs[1].key = `behaviour_${count}_type`
        if (singleRow.rowInputs[2]) singleRow.rowInputs[2].key = `behaviour_${count}_question_type`
      })
    },
    applyUidOrder(uidOrder) {
      const blocksByUid = new Map(this.items.filter(item => item.itemUid !== undefined).map(item => [item.itemUid, item]))
      const reordered = []
      uidOrder.forEach(uid => {
        const block = blocksByUid.get(uid)
        if (block) {
          reordered.push(block)
          blocksByUid.delete(uid)
        }
      })
      blocksByUid.forEach(block => reordered.push(block))
      this.items = reordered
    },
    reorderItems(uidOrder) {
      if (!uidOrder || !uidOrder.length || !this.items.length) return
      this.applyUidOrder(uidOrder)
      this.items.forEach((row, index) => this.relabelRows(index))
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        let totalRows = 0
        // eslint-disable-next-line no-return-assign
        this.items.forEach(item => (totalRows += item.singleRow.length))
        this.trSetHeight(
          this.$refs.form.scrollHeight
            + totalRows * 120
            + this.items.length * 50,
        )
      })
    },
    getData() {
      const behaviours = []

      // eslint-disable-next-line array-callback-return
      this.items.map(item => {
        if (!item.deleted) {
          const temFormat = {
            activity: item.mainTitle,
            behaviours: item.singleRow.map(singleRow => {
              const behaviour = {
                type: singleRow.rowInputs[1].value?.value,
                name: singleRow.rowInputs[0].value,
              }
              const questionTypes = (singleRow.rowInputs[2]?.value || []).map(e => oid(e))
              if (questionTypes.length) behaviour.question_type = questionTypes

              return behaviour
            }),
          }
          behaviours.push(temFormat)
        }
      })
      return { behaviours }
    },
    async createForm() {
      const itemsCount = this.items.length
      const blocksByUid = new Map(this.items.filter(item => item.itemUid !== undefined).map(item => [item.itemUid, item]))
      this.addedActivities.forEach(activity => {
        const existing = blocksByUid.get(activity.uid)
        if (existing) {
          existing.mainTitle = activity.singleRow.rowInputs[0].value
          existing.deleted = activity.singleRow.rowInputs[0].deleted
        } else {
          const payload = {
            itemUid: activity.uid,
            mainTitle: activity.singleRow.rowInputs[0].value,
            deleted: activity.singleRow.rowInputs[0].deleted,
            singleRow: [
              {
                uid: rowUid++,
                rowAttributes: {},
                rowInputs: [
                  {
                    md: 5,
                    label: i18n.tc('message.behaviour_no', 0, {count: '1.1'}),
                    type: 'quill',
                    key: 'behaviour_1.1',
                    rules: 'required',
                    placeholder: i18n.t('placeholder.activity'),
                    value: '',
                  },
                  {
                    md: 2,
                    label: i18n.tc('message.type_no', 0, {count: '1.1'}),
                    type: 'select',
                    key: 'behaviour_1.1_type',
                    rules: 'required',
                    options: constants.types,
                    placeholder: i18n.t('placeholder.type'),
                    value: '',
                  },
                  this.questionTypeInput('1.1'),
                ],
              },
            ],
          }
          this.items.push(payload)
          blocksByUid.set(activity.uid, payload)
        }
      })
      this.applyUidOrder(this.addedActivities.map(activity => activity.uid))
      if (!itemsCount && this.data.length > 0) {
        const available = this.data.slice()
        this.items.forEach((item, idx) => {
          if (item.deleted) return
          const dataIndex = available.findIndex(val => val.activity === item.mainTitle)
          if (dataIndex === -1) return
          const [val] = available.splice(dataIndex, 1)
          item.singleRow = []
          val.behaviours.forEach(behaviour => {
            this.repeatAgain(
              idx,
              val.activity,
              behaviour.name,
              _.find(constants.types, { value: behaviour.type }),
              behaviour.question_type?.map(q => idToString(q)) || [],
            )
          })
        })
      }
      this.items.forEach((row, index) => this.relabelRows(index))
      this.initTrHeight()
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.behaviour-drag-handle {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
</style>
